const fileUrl = '/file';

export default fileUrl;
